
import Vue from "vue";

export default Vue.extend({
  name: "CompanyScopeSelect",
  props: {
    value: {
      type: Number as () => number | null,
      default: null,
    },
    companies: {
      type: Array as () => any[],
      default: () => [],
    },
  },
  data() {
    return {
      open: false,
      search: "",
    };
  },
  computed: {
    selectedLabel(): string {
      if (this.value === null) return "Platform";
      const c = this.companies.find((c: any) => c.id === this.value);
      return c ? c.title || c.name : "Platform";
    },
    filteredCompanies(): any[] {
      if (!this.search.trim()) return this.companies;
      const term = this.search.toLowerCase();
      return this.companies.filter((c: any) => (c.title || c.name || "").toLowerCase().includes(term));
    },
  },
  methods: {
    select(id: number | null) {
      this.$emit("input", id);
      this.open = false;
      this.search = "";
    },
  },
});
